export default __webpack_public_path__ + "static/media/girl2.c1222fab.svg";